// ============================================================================
// PORTAL NOTIFICATIONS REPOSITORY
// ARQUIVO: src/services/PortalNotificationsRepository.js
// RESPONSABILIDADE: Observa notificações do portal (docs, tasks, invoices).
// Criado: Fase 6.3 — mover Firestore direto de usePortalNotifications.js para repositório.
// ============================================================================

import { collection, onSnapshot, query, where, limit } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';

/** Observa documentos pendentes de consentimento do cliente. */
export function watchPendingDocuments(appId, clientId, onData) {
  const q = query(
    collection(db, 'artifacts', appId, 'public', 'data', 'documents'),
    where('clientId', '==', clientId),
    where('requiresConsent', '==', true),
    limit(20)
  );
  return onSnapshot(q, (snap) => {
    onData(snap.docs
      .map(d => ({ id: d.id, ...d.data() }))
      .filter(d => d.clientVisible !== false && !d.consentAccepted && !d.consentDeclined)
    );
  }, () => onData([]));
}

/** Observa tarefas pendentes do cliente. */
export function watchPendingTasks(appId, clientId, onData) {
  const q = query(
    collection(db, 'artifacts', appId, 'public', 'data', 'client_tasks'),
    where('clientId', '==', clientId),
    where('status', '==', 'pending'),
    limit(20)
  );
  return onSnapshot(q, (snap) => {
    onData(snap.docs.map(d => ({ id: d.id, ...d.data() })));
  }, () => onData([]));
}

/** Observa invoices pendentes do cliente. */
export function watchPendingInvoices(appId, clientId, onData) {
  const q = query(
    collection(db, 'artifacts', appId, 'public', 'data', 'invoices'),
    where('clientId', '==', clientId),
    where('status', '==', 'PENDING'),
    limit(20)
  );
  return onSnapshot(q, (snap) => {
    onData(snap.docs.map(d => ({ id: d.id, ...d.data() })));
  }, () => onData([]));
}
